import { useQuery } from "@tanstack/react-query"
import { getProductsByCategory } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useProductsByCategory(category: string | null) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["products-by-category", category],
    queryFn: () => getProductsByCategory(category!, accessToken ?? undefined),
    enabled: !!category,
  })
}